import {combineReducers} from 'redux';
import changeCategoryReducer from '../reducers/changeCategoryReducer'
import categoryListReducer from '../reducers/categoryListReducer'
import movieListReducer from '../reducers/movieListReducer'
import detailReducer from '../reducers/detailReducer'
import topMoviesReducer from '../reducers/topMoviesReducer'
import categorizedMoviesReducer from '../reducers/categorizedMoviesReducer'
import similarMoviesReducer from '../reducers/similarMoviesReducer'



const rootReducer = combineReducers({
    changeCategoryReducer,
    categoryListReducer,
    movieListReducer,
    topMoviesReducer,
    detailReducer,
    categorizedMoviesReducer,
    similarMoviesReducer
})

export default rootReducer;